import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

Vue.use(VueRouter)

const SITE_TITLE = '桂运宝货运平台'
const SITE_DESCRIPTION = '广西桂运宝科技有限公司，专注大宗公路货物运输，覆盖西南、华南、华东等主要省市。'
const SITE_ORIGIN = 'https://guiyunbao.cn'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    meta: {
      title: '桂运宝货运平台 - 首页',
      description: '广西桂运宝科技有限公司，专注大宗公路货物运输，覆盖西南、华南、华东等主要省市。',
      canonicalPath: '/'
    }
  },
  {
    path: '/about',
    name: 'About',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/About.vue'),
    meta: {
      title: '关于我们 - 桂运宝货运平台',
      description: '了解广西桂运宝科技有限公司与大宗货运服务网络。',
      canonicalPath: '/about'
    }
  },
  {
    path: '/news',
    name: 'News',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/News.vue'),
    meta: {
      title: '行业资讯 - 桂运宝货运平台',
      description: '查看桂运宝货运平台发布的行业资讯与物流动态。',
      canonicalPath: '/news'
    }
  },
  {
    path: '/companynews',
    name: 'companynews',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/OurNews.vue'),
    meta: {
      title: '公司新闻 - 桂运宝货运平台',
      description: '查看桂运宝公司新闻、公告与业务进展。',
      canonicalPath: '/companynews'
    }
  },
  {
    path: '/newsdetail/:id?',
    name: 'newsdetail',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/NewsDetail.vue'),
    meta: {
      title: '新闻详情 - 桂运宝货运平台',
      description: '查看桂运宝新闻详情与发布信息。'
    }
  },
  {
    path: '/truckage',
    name: 'Truckage',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/showtruckage.vue'),
    meta: {
      title: '专线及运费查询 - 桂运宝货运平台',
      description: '查询桂运宝专线与省市运费信息。',
      canonicalPath: '/truckage'
    }
  },
  // {
  //   path: '/roadmap',
  //   name: 'roadmap',
  //   component: () => import(/* webpackChunkName: "about" */ '../views/RoadmapView.vue')
  // },
  // 出于浏览速度原因，暂时取消

]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})
router.beforeEach((to, from, next) => {
  const title = (to.meta && to.meta.title) || SITE_TITLE
  const description = (to.meta && to.meta.description) || SITE_DESCRIPTION
  const canonicalPath = (to.meta && to.meta.canonicalPath) || to.path || '/'

  document.title = title

  let descriptionTag = document.querySelector('meta[name="description"]')
  if (!descriptionTag) {
    descriptionTag = document.createElement('meta')
    descriptionTag.setAttribute('name', 'description')
    document.head.appendChild(descriptionTag)
  }
  descriptionTag.setAttribute('content', description)

  let canonicalLink = document.querySelector('link[rel="canonical"]')
  if (!canonicalLink) {
    canonicalLink = document.createElement('link')
    canonicalLink.setAttribute('rel', 'canonical')
    document.head.appendChild(canonicalLink)
  }
  canonicalLink.setAttribute('href', SITE_ORIGIN + canonicalPath)

  window.scrollTo(0, 0)
  next()
})

export default router
